import AlertService from '../../services/alert_service.js';
import GeneralService from '../../services/general_service.js';
import LoginService from '../../services/login_service.js';
import FacturacionService from '../../services/facturacion_service.js';
import InternacionService from '../../services/internacion_service.js';
import CirugiaService from '../../services/cirugia_service.js';
import PacienteService from '../../services/paciente_service.js';

const alertService = new AlertService();
const loginService = new LoginService();
const generalService = new GeneralService();
const internacionService = new InternacionService();
const facturacionService = new FacturacionService();
const cirugiaService = new CirugiaService();
const pacienteService = new PacienteService();

let _this;
export default {
	name: 'facturar',
	props: {
		cirugia: {},
		closeModal:  {
			type: Function,
			default() {
				return "";
			}
		},
	},
	data: function() {
		return {
			titulo: 'Facturar',
			data: {fechaCargaFacturacion: new Date().toISOString().split('T')[0], diferencialFacturacion: 0},
			procedimientos: [],
			generalService: generalService,
			pacienteInternacion: {},
			diagnosticos:[],
			condicionesAlta: [],
			validaciones: {},
			loginService: loginService,
			submited: false,
			obrasSociales: {}
		} 
	}, 
	created: function () {
		_this = this;
		this.submited = false;
		/*this.getDiagnosticos();
		this.getCondicionesAlta();
		this.getData();*/
		this.getCirugia();
	}, 
	methods: { 
		getCirugia() {
			if(_this.cirugia.idCirugia != undefined) {
				let searchCirugia = {};
				if(_this.cirugia.idCirugia != undefined) {
					_this.data.idCirugia = _this.cirugia.idCirugia;
					searchCirugia = {idCirugia: _this.data.idCirugia}
				}
				cirugiaService.get(searchCirugia).then(function(response) {
					if(response.body == null) {
						alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
						return;
					}
					if(response.body && response.body.status == 'ERROR') {
						alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
						return;
					}
					_this.submited = false;
					if(response.body.length > 0) {
						for (let value of response.body) {
							_this.data = {
								idCirugia: value.idCirugia,
								viaCirugia: value.viaCirugia,
								idInternacionCirugia: value.idInternacionCirugia,
								fechaCirugia: value.fechaCirugia,
								idViaCirugia: value.idViaCirugia,
								idCirujanoCirugia: value.idCirujanoCirugia,
								procedimientosCirugia: [],
								idFacturacion: value.facturacion ? value.facturacion.idFacturacion : "",
								idCirugiaFacturacion: value.idCirugia,
								valorFacturacion: value.facturacion ? value.facturacion.valorFacturacion : "",
								cobradoFacturacion: value.facturacion ? value.facturacion.cobradoFacturacion : "",
								diferencialFacturacion: value.facturacion ? value.facturacion.diferencialFacturacion : 0,
								fechaCargaFacturacion: value.facturacion && value.facturacion.fechaCargaFacturacion ? value.facturacion.fechaCargaFacturacion : new Date().toISOString().split('T')[0],
								idPrimerAyudanteCirugia: value.idPrimerAyudanteCirugia,
								idSegundoAyudanteCirugia: value.idSegundoAyudanteCirugia,
								cirujanoCirugia: value.cirujanoCirugia,
								primerAyudanteCirugia: value.primerAyudanteCirugia,
								segundoAyudanteCirugia: value.segundoAyudanteCirugia,								
								col1Cirugia: value.col1Cirugia,
								col2Cirugia: value.col2Cirugia,
								col3Cirugia: value.col3Cirugia,
								internacion: value.internacion,								
							}; 
							_this.data.nombrePaciente = _this.data.internacion.pacienteInternacion.nombrePaciente,
							_this.data.apellidoPaciente =  _this.data.internacion.pacienteInternacion.apellidoPaciente,
							_this.data.dniPaciente =  _this.data.internacion.pacienteInternacion.dniPaciente,
							_this.data.pacienteInternacion = pacienteService.formatPaciente(_this.data.internacion.pacienteInternacion);
							_this.data.pacienteInternacionCirugia = internacionService.formatInternacion(_this.data.internacion);
							_this.titulo = 'FACTURAR CIRUGIA ' + pacienteService.datosPersonalesPaciente(_this.data.internacion.pacienteInternacion).toUpperCase();
							_this.getProcedimientosCirugia();
						} 
					} 
				}, function(error) { 
					_this.submited = false;
					generalService.showRequestErrors(error, _this.$bvModal);
					return;
				});
				//_this.getData();
			} else {
				_this.cancelar();
			}
		},
		getProcedimientosCirugia: function() {
			_this.data.procedimientosCirugia = [];
			_this.searchProcedimientos = true;
			cirugiaService.getProcedimientosCirugia({idCirugia: _this.cirugia.idCirugia}).then(function(response) {	
				_this.searchProcedimientos = false;				
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.procedimientos.push(value);
						_this.data.procedimientosCirugia.push({idProcedimiento: value.idProcedimiento, descripcionDatoParametrico: value.descripcionProcedimiento});
					}
				} 
			}, function(error) { 
				_this.searchProcedimientos = false;				
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		save: function() {
			let errores = this.validar();
			if (errores) {
				/*let errores = "";
				for(const prop in validaciones) {
					for(const error of validaciones[prop].errores) {
						errores+= error + '
';
					}
				}*/
				alertService.showAlert(this.$bvModal, 'warning', 'Advertencia', 'No se completaron correctamente los datos.\nVerifique los errores en el formulario.');
				return;
			}
			let data = {
				idFacturacion: this.data.idFacturacion,
				idCirugiaFacturacion: this.data.idCirugiaFacturacion,
				valorFacturacion: this.data.valorFacturacion,
				cobradoFacturacion: this.data.cobradoFacturacion,
				diferencialFacturacion: this.data.diferencialFacturacion,
				fechaCargaFacturacion: this.data.fechaCargaFacturacion,
				col1Facturacion: this.data.col1Facturacion,
				col2Facturacion: this.data.col2Facturacion,
				col3Facturacion: this.data.col3Facturacion,
			}; 
			this.submited = true;
			facturacionService.save(data).then(function(response) {
				if(response.body && response.body.status == 'success') {
					alertService.showSuccessToast('Datos guardados con exito.'); 
					_this.cancelar();
				}
				_this.submited = false; 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		validar: function() {
			let validaciones = {};
			let errores = false;
			if (typeof this.data.idCirugiaFacturacion == 'undefined' || this.data.idCirugiaFacturacion == '') {
				errores = true;
				validaciones['idCirugiaFacturacion'] = {errores: ['El Id Cirugia Facturacion es obligatorio.'], estado: false};
			}
			if (typeof this.data.valorFacturacion == 'undefined' || this.data.valorFacturacion == '' || isNaN(this.data.valorFacturacion)) {
				errores = true;
				validaciones['valorFacturacion'] = {errores: ['El campo Valor es obligatorio.'], estado: false};
			}
			if (typeof this.data.cobradoFacturacion == 'undefined' || this.data.cobradoFacturacion == ''  || isNaN(this.data.cobradoFacturacion)) {
				errores = true;
				validaciones['cobradoFacturacion'] = {errores: ['El campo Cobrado es obligatorio.'], estado: false};
			}
			if (typeof this.data.diferencialFacturacion == 'undefined' || this.data.diferencialFacturacion == '') {
				errores = true;
				validaciones['diferencialFacturacion'] = {errores: ['El campo Diferencial es obligatorio.'], estado: false};
			}
			if (typeof this.data.fechaCargaFacturacion == 'undefined' || this.data.fechaCargaFacturacion == '') {
				errores = true;
				validaciones['fechaCargaFacturacion'] = {errores: ['La Fecha de Carga Facturacion es obligatoria.'], estado: false};
			}
			this.validaciones = validaciones;
			return errores;
		},
		limpiarError: function (campo) {
			if (campo == undefined || campo.errores.length == 0) {
				return true;
			}
			campo.errores.length = 0;
			campo.estado = true;
		},
		diferencial: function () {
			this.limpiarError(this.validaciones.valorFacturacion);
			this.limpiarError(this.validaciones.cobradoFacturacion);
			this.data.diferencialFacturacion = 0;
			if(!isNaN(this.data.valorFacturacion)) {
				this.data.diferencialFacturacion = this.data.valorFacturacion;
			}
			if(!isNaN(this.data.cobradoFacturacion)) {
				this.data.diferencialFacturacion = this.data.diferencialFacturacion - this.data.cobradoFacturacion;
			}
		},
		cancelar: function() {
			_this.resetModal();
		},
		resetModal: function() {
			_this.data = {};
			if(_this.$refs['facturar'])	_this.closeModal();
			
		}
	}
}

